<template>
  <div v-if="isEmptySearchedNutriProZTest" class="px-2.5 grid grid-cols-2 gap-2">
      <TestCard
        ref="nutriprozTest"
        v-for="node in nutriprozTestList"
        :key="node.id"
        :test-group-node="node"
        :select-prop="selectProp"
        :is-not-allowed-select-prop="isNotAllowedSelectProp"
        :order-test-support-obj="orderTestSupportObj"
        class="mb-3"
      />
  </div>
  <TestCard
    v-else
    ref="nutriprozTest"
    :key="rootForSearchedNutriProZTest.id"
    class="ml-2.5 searched-test w-1/2"
    :test-group-node="rootForSearchedNutriProZTest"
    :filtered-test="searchedNutriProZTest"
    :is-show-expand="true"
    :select-prop="selectProp"
    :is-not-allowed-select-prop="isNotAllowedSelectProp"
    :order-test-support-obj="orderTestSupportObj"
  />
</template>

<script>
import TestCard from "./TestCard.vue";
import _ from "lodash";

export default {
  components: {
    TestCard
  },

  props: {
    nutriprozTestList: {
      type: Array,
      default: () => []
    },
    rootForSearchedNutriProZTest: {
      type: Object,
      default: () => {}
    },
    searchedNutriProZTest: {
      type: Object,
      default: () => {}
    },
    selectProp: {
      type: String,
      default: "isSelect"
    },
    isNotAllowedSelectProp: {
      type: String,
      default: "isNotAllowedSelect"
    },    
    orderTestSupportObj: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    isEmptySearchedNutriProZTest() {
      return _.isEmpty(this.rootForSearchedNutriProZTest);
    },
  }
}
</script>

<style scoped>
.searched-test {
  border: 2px solid #3498db;
  box-shadow: 0px 2px 6px rgba(48, 48, 48, 0.13);
}
</style>

